// MultipleSelect.styles.js
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  selectRoot: {
    height: '37.63px',
    padding: '10.5px 14px',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    fontSize: '14px',
    overflowX: 'auto',
  },
  menuItem: {
    fontSize: '14px',
  },
}));

export default useStyles;
